import { Icon as BlueIcon } from '@blueprintjs/core';
import { useContext, useEffect } from 'react';
import { useInView } from 'react-intersection-observer';
import { useHistory } from 'react-router-dom';

import Rolling from '@assets/gif/rolling.gif';
// import UserImage from '@assets/png/user.png';

// import { GlobalMenu } from '@components/index';
import { IIdentificationRequestsRaw } from '@models/IdentificationRequests.model';
// import { ReactComponent as UnreadMessageIcon } from '@assets/svg/unread-messaage.svg';
// import { ReactComponent as ReadMessageIcon } from '@assets/svg/read-message.svg';
import { NavigationContext } from '@layout/navigation/navigation';
import {
  CountLoading,
  TableContentLoading,
} from './IdentificationRequests.loading';
import {
  Container,
  Content,
  Header,
  Title,
  Line,
  Heading,
  Spacing,
  LineText,
  ColumnName,
  ColumnContainer,
  NoText,
  Item,
  LoadMore,
  LoadingText,
  LoadingImg,
  TabsContainer,
  Tabs,
  ItemTab,
  Back,
  Indicator,
  Label,
  LabelText,
  Count,
  LineTextContainer,
  // MenuContainer,
  Buttons,
  InputContainer,
  SearchIconContainer,
  InputSearch,
  IdentificationRequestsTools,
  AssineeWrapper,
  AssineeImage,
} from './IdentificationRequests.styles';
import { EmptyIdentificationRequests } from './components/EmptyIdentificationRequests/EmptyIdentificationRequests';
import { IdentificationRequestsStatus } from './components/IdentificationRequestsStatus/IdentificationRequestsStatus';
import { IdentificationRequestsDate } from './components/IdentificationRequestsDate/IdentificationRequestsDate';
import { IdentificationRequestsContext } from './IdentificationRequests.query';
import { IdentificationRequestsError } from './IdentificationRequests.error';
import { IdentificationRequestChat } from './components/IdentificationRequestChat/IdentificationRequestChat';
import { Filter } from './components/Filter/Filter';
import { RequestAssigneeDialog } from './components/RequestAssigneeDialog/RequestAssigneeDialog';

interface IFillOrEmpty {
  label: string | number;
  disabled?: boolean;
}

export const FillOrEmpty = ({ label, disabled = false }: IFillOrEmpty) => {
  if (label === '' || label === undefined || label === null) {
    return <NoText>Empty</NoText>;
  }

  return (
    <LineTextContainer>
      <LineText limitOfLines={1} disabled={disabled}>
        {label}
      </LineText>
    </LineTextContainer>
  );
};

interface IColumnTitle {
  label: string;
}

export const ColumnTitle = ({ label, ...rest }: IColumnTitle) => {
  return (
    <ColumnContainer {...rest}>
      <ColumnName>{label}</ColumnName>
    </ColumnContainer>
  );
};

const CountComponent = ({ count }: { count?: number }) => {
  if (count !== undefined) {
    return <Count>{count}</Count>;
  }

  return <CountLoading />;
};

const IdentificationRequestsRaw = ({
  filesQuery,
  fetchNextPage,
  isError,
  isLoading,
}: IIdentificationRequestsRaw) => {
  const {
    status,
    identificationRequestsCount,
    assignedToMe,
    openChat,
    selectedRequest,
  } = useContext(IdentificationRequestsContext);

  const { userPicture } = useContext(NavigationContext);

  const { ref, inView } = useInView();

  const history = useHistory();

  const hasMore = filesQuery
    ? !filesQuery.pages[filesQuery.pages.length - 1].isLastPage
    : false;

  const files = filesQuery
    ? filesQuery.pages
        .map(pageData => pageData.assets)
        .reduce(function reduce(prev, next) {
          return prev.concat(next);
        })
    : [];

  useEffect(() => {
    if (inView && hasMore) fetchNextPage();
  }, [inView, hasMore]);

  const selectedRequestValue = selectedRequest.value;

  return (
    <Container>
      <Header>
        <Title>Beam Admin Identification Requests</Title>
      </Header>

      {openChat.get() && selectedRequestValue && (
        <IdentificationRequestChat
          open={openChat.get()}
          onClose={() => openChat.set(false)}
        />
      )}

      <TabsContainer>
        <Tabs>
          <ItemTab
            onClick={() => {
              history.push('/identificationRequests?tab=open');
            }}
          >
            <Label>
              <LabelText isActive={status === 'open'}>Open</LabelText>

              <CountComponent count={identificationRequestsCount?.open} />
            </Label>

            <Indicator isActive={status === 'open'} />
          </ItemTab>
          <ItemTab
            onClick={() => {
              history.push('/identificationRequests?tab=resolved');
            }}
          >
            <Label>
              <LabelText isActive={status === 'resolved'}>Resolved</LabelText>

              <CountComponent count={identificationRequestsCount?.resolved} />
            </Label>

            <Indicator isActive={status === 'resolved'} />
          </ItemTab>
          <ItemTab
            onClick={() => {
              history.push('/identificationRequests?tab=closed');
            }}
          >
            <Label>
              <LabelText isActive={status === 'closed'}>Closed</LabelText>

              <CountComponent count={identificationRequestsCount?.closed} />
            </Label>

            <Indicator isActive={status === 'closed'} />
          </ItemTab>
        </Tabs>
        <Back />
      </TabsContainer>

      <IdentificationRequestsTools>
        <Buttons>
          <InputContainer>
            <SearchIconContainer>
              <BlueIcon icon="search" color="#DADADA" />
            </SearchIconContainer>
            <InputSearch placeholder="Search" />
          </InputContainer>
          <AssineeWrapper
            active={assignedToMe.value}
            onClick={() => {
              assignedToMe.set(!assignedToMe.value);
            }}
          >
            <AssineeImage src={userPicture} alt="User" />
            <span>Assigned to Me</span>
          </AssineeWrapper>
          <Filter />
        </Buttons>
      </IdentificationRequestsTools>

      {filesQuery && files.length === 0 ? (
        <EmptyIdentificationRequests
          title="No identification requests yet!"
          message="Your identification requests actions will show here once initiated."
        />
      ) : (
        <Spacing>
          <Heading>
            <ColumnTitle label="ID" />
            <ColumnTitle label="Studio" />
            <ColumnTitle label="Source" />
            <ColumnTitle label="Identification Error" />
            <ColumnTitle label="Assigned To" />
            <ColumnTitle label="Request Date" />
            <ColumnTitle label="Request Status" />
            <div />
          </Heading>
        </Spacing>
      )}

      {filesQuery && (
        <Content>
          {files.map(file => {
            return (
              <Item
                key={file.id}
                onClick={e => {
                  openChat.set(true);
                  selectedRequest.set(file);
                  e.stopPropagation();
                }}
              >
                <Line $unreadMessages={false}>
                  <FillOrEmpty label={file.id} disabled />
                  <FillOrEmpty label={file.studioName} />
                  <FillOrEmpty label={file.source} />
                  <FillOrEmpty label={file.idenficationError} />

                  <RequestAssigneeDialog
                    file={{
                      avatar: file?.assigned?.avatar,
                      name: file?.assigned?.name,
                    }}
                    threadId={file.threadId}
                    selectedGroup={file?.assigned?.id}
                  />

                  <IdentificationRequestsDate
                    requestDate={new Date(file.createdAt)}
                  />
                  <IdentificationRequestsStatus status={file.status} />
                  {/* <CommentBox>
                    {file.id ? <UnreadMessageIcon /> : <ReadMessageIcon />}
                  </CommentBox> */}
                </Line>
              </Item>
            );
          })}

          <LoadMore ref={ref}>
            {hasMore ? (
              <LoadMore>
                <LoadingText>Loading more</LoadingText>
                <LoadingImg src={Rolling} alt="loading" />
              </LoadMore>
            ) : (
              <div />
            )}
          </LoadMore>
        </Content>
      )}

      {isLoading && <TableContentLoading />}

      {isError && (
        <IdentificationRequestsError message="Error on loading files" />
      )}
    </Container>
  );
};

export { IdentificationRequestsRaw };
